module.exports = __webpack_public_path__ + "static/media/contact-img.02062751.svg";